import { IVariant, IVariantDCOV } from "../../interfaces";
import { getItemMargin, getOstr } from "../utils";
import { getPrice, getWidths, getPriceHeader } from "../price";
import {
  covGroupProvider,
  covPriceProvider,
} from "../../providers/covProvider";

const getCov = (variant: IVariant | IVariantDCOV) => {
  const filtered = variant.cov.filter((g) => g.quantity > 0);
  const groups = covGroupProvider(filtered);

  // Skip
  if (filtered.length === 0) {
    return [];
  }

  return [
    {
      stack: [
        { text: "ČOV domovní", style: "h4" },
        {
          layout: "lightHorizontalLines",
          table: {
            widths: getWidths(3),
            body: [
              [
                { text: "Název větve", style: "tableHeader" },
                { text: "Velikost", style: "tableHeader" },
                { text: "Počet", style: "tableHeader" },
                ...getPriceHeader(),
              ],
              ...filtered.map((g) => [
                getOstr(g.name),
                g.type,
                g.quantity,
                ...getPrice(g, covPriceProvider),
              ]),
              ["", "", "", "", ""],
              ...groups.map((g, index) => [
                `Mezisoučet #${index + 1}`,
                g.type,
                g.quantity,
                ...getPrice(g, covPriceProvider),
              ]),
              [
                "Celkový součet",
                "",
                "",
                ...getPrice(filtered, covPriceProvider),
              ],
            ],
          },
        },
      ],
      unbreakable: true,
      ...getItemMargin(),
    },
  ];
};

export default getCov;
